/**
 * MSAL (Microsoft Authentication Library) Configuration
 * Configure Azure AD authentication settings
 */
import { Configuration, PopupRequest } from '@azure/msal-browser';

// Get Azure AD configuration from environment variables
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || '';
const redirectUri = process.env.REACT_APP_AZURE_REDIRECT_URI || `${window.location.origin}/auth/callback`;
const localDevAuthBypass = process.env.REACT_APP_LOCAL_DEV_AUTH_BYPASS === 'true';

// MSAL still requires a syntactically valid client ID to render its provider.
// This inert value is never used for an Azure request because isSSOConfigured()
// remains false when the real Azure settings are absent.
const fallbackClientId = '00000000-0000-0000-0000-000000000001';

// Validate required configuration
if (!clientId || !tenantId) {
  console.info('Azure AD is not configured; password or local development authentication is available.');
}

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: clientId || fallbackClientId,
    authority: tenantId ? `https://login.microsoftonline.com/${tenantId}` : 'https://login.microsoftonline.com/common',
    redirectUri: redirectUri,
    // /auth/callback owns handleRedirectPromise() and the final app navigation.
    // Prevent MSAL from navigating away before that callback can exchange the ID token.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Check if Azure AD is properly configured
export const isSSOConfigured = (): boolean => {
  return !!(clientId && tenantId);
};

// This only changes browser behaviour when explicitly injected into the local
// development process. It is false in every normal build and deployment.
export const isLocalDevAuthBypassEnabled = (): boolean => localDevAuthBypass;

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ['User.Read'],
};

// Add here the endpoints and scopes when obtaining an access token for protected web APIs.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
